import OSS from 'ali-oss'

// /**
//  * 获取配置
//  * @param region shanghai beijing
//  * @returns {{region: string, accessKeyId: string, accessKeySecret: string, bucket: string}}
//  */
const accessKeySecret = 'bU4sgGg8kglVmdBKAvqMzCr1oZdeWr'
const accessKeyId = 'LTAI5tP6etTPDFKs1TpMnurg'
const node_env = process.env.NODE_ENV
// const node_env = "development"

/**
 * 根据环境获取oss配置
 * @param env
 * @returns {{region: string, accessKeyId: string, accessKeySecret: string, bucket: string}}
 */
function getOptionsByEnv(env) {
  switch (env) {
    // 公共桶
    case "public":
      return {
        region: 'oss-cn-shanghai',
        accessKeyId,
        accessKeySecret,
        bucket: ['development', 'staging', 'test'].indexOf(node_env) > -1 ? "health-test-public-yz" : 'health-pro-public-yz'
      }
    // 私有桶
    case "private":
      return {
        region: 'oss-cn-shanghai',
        accessKeyId,
        accessKeySecret,
        bucket: ['development', 'staging', 'test'].indexOf(node_env) > -1 ? "health-test-private-yz" : 'health-pro-private-yz'
      }
    default:
      return {
        region: 'oss-cn-beijing', accessKeyId, accessKeySecret, // bucket: 'health-test-yz'
        bucket: 'mall-test-yz'
      }
  }
}

/**
 *  获取Oss
 *  @param env
 * @returns {oss}
 */
export function createClient(env = "private") {
  const ossOptions = getOptionsByEnv(env)
  const resultOptions = {
    // 从环境变量中获取访问凭证。运行本代码示例之前，请确保已设置环境变量OSS_ACCESS_KEY_ID和OSS_ACCESS_KEY_SECRET。
    accessKeyId: ossOptions.accessKeyId, accessKeySecret: ossOptions.accessKeySecret, // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: ossOptions.region, authorizationV4: true, // yourBucketName填写Bucket名称。
    bucket: ossOptions.bucket, secure: true
  }
  return new OSS(resultOptions)
}

export function getSrc(client, src) {
  client = client || createClient()
  if (!src) return ''
  return client.signatureUrl(src, { expires: 999999999999999 }) // 可访问的链接
}
